import React, { Component, Fragment } from "react";
import { Card, Spin, Form, Button, Row } from "antd";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import { locationPrefix } from "common/general";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";

const FormItem = Form.Item;

@inject("rootStore")
@observer
class CustomSitesPage extends Component {
	collapseAll = () => {};

	expandAll = () => {};

	render() {
		const {
			rootStore: { customSitesStore }
		} = this.props;

		const ui = customSitesStore.ui;
		const verifierStatus = customSitesStore.verifierStatus;

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Custom Sites"
			}
		];

		const spinning = false;

		return (
			<Fragment>
				{ui.loadingPrivateNetwork == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title="Custom Sites"
					>
						<Card>
							<Spin spinning={spinning}>
								<Row>
									<Form layout="inline">
										<FormItem>
											<Button type="primary">
												Add
											</Button>
										</FormItem>
										<FormItem>
											<Button type="primary">
												Import
											</Button>
										</FormItem>
										<FormItem>
											<Button type="primary">
												Import All
											</Button>
										</FormItem>		
										<FormItem>
											<Button type="primary">
												Export All
											</Button>
										</FormItem>
										<FormItem>
											<Button type="primary">
												Delete
											</Button>
										</FormItem>																			
									</Form>
								</Row>
								<Row>
									<Form layout="inline">
										<FormItem>
											<Button
												type="primary"
												icon="minus"
												onClick={this.collapseAll}
											>
												Collapse
											</Button>
										</FormItem>
										<FormItem>
											<Button
												type="primary"
												icon="plus"
												onClick={this.expandAll}
											>
												Expand
											</Button>
										</FormItem>
									</Form>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default CustomSitesPage;
